"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChannelValue = void 0;
var react_1 = __importStar(require("react"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var css_1 = require("@emotion/css");
var prop_types_1 = __importDefault(require("prop-types"));
var styles_1 = require("@mui/material/styles");
var ChannelValueClasses_1 = __importStar(require("./ChannelValueClasses"));
var base_1 = require("@mui/base");
var Box_1 = __importDefault(require("@mui/material/Box"));
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        icon: ['icon'],
        text: ['text'],
        value: ['value'],
        units: ['units'],
    };
    return (0, base_1.unstable_composeClasses)(slots, ChannelValueClasses_1.getChannelValueUtilityClass, classes);
};
var Root = (0, styles_1.styled)(Box_1.default)(function (_a) {
    var _b;
    var fontSize = _a.fontSize, color = _a.color;
    return (_b = {
            display: 'inline-flex',
            alignItems: 'center',
            lineHeight: 1.2,
            fontSize: fontSize,
            color: color
        },
        _b["& .".concat(ChannelValueClasses_1.default.text)] = { fontSize: 'inherit', lineHeight: 'inherit', letterSpacing: 0 },
        _b);
});
var IconSpan = (0, styles_1.styled)('span', {})(function () { return ({
    marginRight: '0.35em',
    display: 'inline',
    fontSize: 'inherit',
}); });
var Unit = (0, styles_1.styled)(Typography_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'isSuffix'; },
})(function (_a) {
    var isSuffix = _a.isSuffix;
    return (__assign({ fontWeight: 300 }, (isSuffix === true && {
        marginLeft: '0.25em',
    })));
});
var Value = (0, styles_1.styled)(Typography_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'isPrefix'; },
})(function (_a) {
    var isPrefix = _a.isPrefix;
    return (__assign({ fontWeight: 600 }, (isPrefix === true && {
        marginLeft: '0.25em',
    })));
});
var changeIconDisplay = function (newIcon) {
    return react_1.default.cloneElement(newIcon, {
        style: Object.assign({}, newIcon.props.style, { display: 'block', fontSize: 'inherit' }),
    });
};
var ChannelValueRender = function (props, ref) {
    var classes = props.classes, userClassName = props.className, icon = props.icon, prefix = props.prefix, units = props.units, unitSpace = props.unitSpace, value = props.value, color = props.color, fontSize = props.fontSize, otherProps = __rest(props, ["classes", "className", "icon", "prefix", "units", "unitSpace", "value", "color", "fontSize"]);
    var defaultClasses = useUtilityClasses(props);
    var prefixUnitAllowSpaceList = ['$'];
    var suffixUnitAllowSpaceList = ['%', '℉', '°F', '℃', '°C', '°'];
    var applyPrefix = (0, react_1.useCallback)(function () {
        return prefix && unitSpace !== 'hide' && (unitSpace === 'show' || !prefixUnitAllowSpaceList.includes(units));
    }, [prefix, units, unitSpace]);
    var applySuffix = (0, react_1.useCallback)(function () {
        return !prefix && unitSpace !== 'hide' && (unitSpace === 'show' || !suffixUnitAllowSpaceList.includes(units));
    }, [prefix, units, unitSpace]);
    var getUnitElement = (0, react_1.useCallback)(function () { return (react_1.default.createElement(react_1.default.Fragment, null, units && (react_1.default.createElement(Unit, { variant: 'h6', color: 'inherit', className: (0, css_1.cx)(defaultClasses.text, classes.text, defaultClasses.units, classes.units), isSuffix: applySuffix(), "data-testid": 'blui-channel-value-units' }, units)))); }, [units, prefix, classes, defaultClasses, unitSpace]);
    return (react_1.default.createElement(Root, __assign({ component: "span", ref: ref, className: (0, css_1.cx)(defaultClasses.root, classes.root, userClassName), "data-testid": 'blui-channel-value-root', fontSize: fontSize, color: color }, otherProps),
        icon && (react_1.default.createElement(IconSpan, { className: (0, css_1.cx)(defaultClasses.icon, classes.icon), "data-testid": 'blui-channel-value-icon' }, changeIconDisplay(icon))),
        prefix && getUnitElement(),
        react_1.default.createElement(Value, { variant: 'h6', color: 'inherit', className: (0, css_1.cx)(defaultClasses.text, classes.text, defaultClasses.value, classes.value), "data-testid": 'blui-channel-value-value', isPrefix: applyPrefix() }, value),
        !prefix && getUnitElement()));
};
/**
 * [ChannelValue](https://brightlayer-ui-components.github.io/react/components/channel-value) component
 *
 * Used to show a stylized value and its units.
 * You may also include an icon.
 */
exports.ChannelValue = react_1.default.forwardRef(ChannelValueRender);
exports.ChannelValue.displayName = 'ChannelValue';
exports.ChannelValue.propTypes = {
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        icon: prop_types_1.default.string,
        text: prop_types_1.default.string,
        prefix: prop_types_1.default.string,
        suffix: prop_types_1.default.string,
        value: prop_types_1.default.string,
        units: prop_types_1.default.string,
    }),
    color: prop_types_1.default.string,
    fontSize: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    icon: prop_types_1.default.element,
    prefix: prop_types_1.default.bool,
    units: prop_types_1.default.string,
    unitSpace: prop_types_1.default.oneOf(['show', 'hide', 'auto']),
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]).isRequired,
};
exports.ChannelValue.defaultProps = {
    classes: {},
    color: 'inherit',
    fontSize: 'inherit',
    prefix: false,
};
